import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-requestbydate',
  templateUrl: './requestbydate.component.html',
  styleUrls: ['./requestbydate.component.css']
})
export class RequestbydateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
